/**
 * Enums and Constants used in multiple
 * collection types
 */
export var CONSTANTS;
(function (CONSTANTS) {
    let STATUS;
    (function (STATUS) {
        STATUS["New"] = "New";
        STATUS["NeedInfo"] = "Needs More Info";
        STATUS["NeedFollowup"] = "Needs Followup";
        STATUS["QuoteRequested"] = "Requested Quote";
        STATUS["QuoteSent"] = "Sent Quote";
        STATUS["ContractSent"] = "Sent Contract";
        STATUS["ClosedCustomer"] = "Closed: New Customer";
        STATUS["ClosedNoSale"] = "Closed: No Sale";
        STATUS["Inactive"] = "Inactive";
        STATUS["Hidden"] = "Hidden";
    })(STATUS = CONSTANTS.STATUS || (CONSTANTS.STATUS = {}));
    ;
    let DISCOUNT_QUALIFIER;
    (function (DISCOUNT_QUALIFIER) {
        DISCOUNT_QUALIFIER["None"] = "0";
        DISCOUNT_QUALIFIER["Teacher"] = "Teacher";
        DISCOUNT_QUALIFIER["Veteran"] = "Veteran";
        DISCOUNT_QUALIFIER["Military"] = "Military";
        DISCOUNT_QUALIFIER["FirstResponder"] = "First Responder";
    })(DISCOUNT_QUALIFIER = CONSTANTS.DISCOUNT_QUALIFIER || (CONSTANTS.DISCOUNT_QUALIFIER = {}));
    ;
    let LEAD_ORIGIN;
    (function (LEAD_ORIGIN) {
        LEAD_ORIGIN["ContactForm"] = "Contact Form";
        LEAD_ORIGIN["Email"] = "Email";
        LEAD_ORIGIN["InPerson"] = "In Person";
        LEAD_ORIGIN["Phone"] = "Phone";
        LEAD_ORIGIN["Facebook"] = "Facebook";
        LEAD_ORIGIN["Twitter"] = "Twitter";
        LEAD_ORIGIN["Instagram"] = "Instagram";
        LEAD_ORIGIN["TikTok"] = "TikTok";
        LEAD_ORIGIN["YouTube"] = "YouTube";
        LEAD_ORIGIN["Podcast"] = "Podcast";
        LEAD_ORIGIN["SocialMedia"] = "Social Media - Other";
        LEAD_ORIGIN["Other"] = "Other or Unknown";
    })(LEAD_ORIGIN = CONSTANTS.LEAD_ORIGIN || (CONSTANTS.LEAD_ORIGIN = {}));
    ;
    let PRODUCT_INTEREST;
    (function (PRODUCT_INTEREST) {
        PRODUCT_INTEREST["Training"] = "Dog Training";
        PRODUCT_INTEREST["Puppy"] = "Dog Training: Puppy";
        PRODUCT_INTEREST["Fundamental"] = "Dog Training: Fundamentals";
        PRODUCT_INTEREST["Advanced"] = "Dog Training: Advanced";
        PRODUCT_INTEREST["Boarding"] = "Boarding";
        PRODUCT_INTEREST["BoardingCE"] = "Boarding: Continuing Education";
        PRODUCT_INTEREST["Other"] = "Other or Unknown";
        // Regular     = "Dog Training: Regular",
        // Specialty   = "Dog Training: Specialty",
    })(PRODUCT_INTEREST = CONSTANTS.PRODUCT_INTEREST || (CONSTANTS.PRODUCT_INTEREST = {}));
    ;
})(CONSTANTS || (CONSTANTS = {}));
//# sourceMappingURL=constants.js.map